import { LoanField, ChecklistItem } from '../types/loan'

// Fee Information section — mirrors the first screenshot, split into logical groups
export const lockFields: LoanField[] = [
  { id: 'lockMaster', label: 'Lock Master', value: 'Nikki Borchers', type: 'user' },
  { id: 'borrowerName', label: 'Borrower Name', value: 'Kathy Rice', editable: false },
  { id: 'investorLoanNumber', label: 'Investor Loan Number', value: '9102594388', editable: true },
  { id: 'waiveEscrow', label: 'Waive Escrow', value: 'No', type: 'boolean', editable: true },
  { id: 'floatLeDisclosed', label: 'Was a Float LE Already Disclosed?', value: 'No', type: 'boolean', editable: true },
  { id: 'applicationDate', label: 'Application Date', value: '5/12/2026', type: 'date', editable: true },
  {
    id: 'addRemoveTitle',
    label: 'Adding or Removing Individual on Title?',
    value: 'No',
    type: 'boolean',
    editable: true,
    info: 'Indicates whether an individual is being added to or removed from the property title.',
  },
]

export const rateFields: LoanField[] = [
  { id: 'rateLockAtReg', label: 'Rate Lock at Reg', value: 'Lock', editable: true },
  { id: 'rateLockPeriod', label: 'Rate Lock Period', value: '30', editable: true },
  { id: 'interestRate', label: 'Interest Rate', value: '5.750%', type: 'percent', editable: true },
  { id: 'expectedPrice', label: 'Expected Price', value: '100.250', editable: true },
  { id: 'lockedFloatPrice', label: 'LockedFloat Price', value: '100.000', editable: true },
  { id: 'investorLockPrice', label: 'Investor Lock Price', value: '101.303', editable: true },
  { id: 'peRequest', label: 'PE Request from Investor', value: '', editable: true },
  { id: 'lockEnteredDate', label: 'Lock Entered Date', value: '5/13/2026', type: 'date', editable: true },
  { id: 'lockExpiration', label: 'Lock Expiration', value: '7/28/2026', type: 'date', editable: true },
  { id: 'baselineRev', label: 'Baseline Rev', value: '1.303%', type: 'percent', editable: false },
]

export const feeFields: LoanField[] = [
  { id: 'underwritingFee', label: 'Underwriting Fee', value: '$0.00', type: 'currency', editable: true },
  { id: 'originationFee', label: 'Origination Fee', value: '', type: 'currency', editable: true },
  { id: 'lenderCredit', label: 'Lender Credit', value: '', type: 'currency', editable: true },
  { id: 'processingFee', label: 'Processing Fee', value: '', type: 'currency', editable: true },
  { id: 'toleranceCures', label: 'Tolerance Cures', value: '', type: 'currency', editable: true },
]

// Loan Details section — mirrors the second screenshot
export const propertyFields: LoanField[] = [
  { id: 'propertyType', label: 'Property Type', value: 'Detached', editable: true },
  { id: 'estCloseDate', label: 'Est Close Date', value: '', type: 'date', editable: true },
  { id: 'isReDoc', label: 'Is This a Re Doc?', value: '', type: 'boolean', editable: true },
  { id: 'vaDisabilityStatus', label: 'VA Disability Status', value: '', editable: true },
  { id: 'regToDisclose', label: 'Reg to Disclose', value: 'Yes', type: 'boolean', editable: false },
]

export const teamFields: LoanField[] = [
  { id: 'leadSource', label: 'Lead Source', value: 'Telemarketing', editable: true },
  { id: 'manager', label: 'Manager', value: 'Taylor Bishop', type: 'user', editable: true },
  { id: 'loanOfficer', label: 'Loan Officer', value: 'Raymond Happel', type: 'user', editable: true },
  { id: 'totalLoanAmount', label: 'Total Loan Amount', value: '$297,888.00', type: 'currency', editable: false },
  { id: 'team', label: 'Team', value: 'The Bullpen', editable: true },
  { id: 'investor', label: 'Investor', value: 'Planet', editable: true },
  { id: 'rcmLoanNumber', label: 'RCM Loan Number', value: '2605110013', editable: true },
  { id: 'investorCost', label: 'Investor Cost', value: '$620.00', type: 'currency', editable: true },
]

export const revenueFields: LoanField[] = [
  { id: 'revenueDollars', label: 'Revenue Dollars', value: '$3,261.48', type: 'currency', editable: false },
  { id: 'revenuePercent', label: 'Revenue Percent', value: '1.095%', type: 'percent', editable: false },
]

// Reg Checklist section — mirrors the third screenshot
export const checklistItems: ChecklistItem[] = [
  { id: 'reviewDraftLe', label: 'Review Draft LE', done: false },
  { id: 'runCio', label: 'Run CIO', done: false },
  { id: 'runAus', label: 'Run AUS', done: false },
  { id: 'printPayoffs', label: 'Print the Payoffs', done: false },
  { id: 'uwmRateSheet', label: 'UWM Undiscounted Rate Sheet', done: false },
  { id: 'loAction', label: 'LO Action', done: false },
  { id: 'addProcessingDate', label: 'Add Processing Date', done: false },
]
